var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12070_274859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3358 8.66522V7.33189H15.3018C14.9831 3.81989 12.1811 1.01722 8.66913 0.699219V2.66522H7.33579V0.699219C3.82379 1.01722 1.02113 3.81989 0.703125 7.33189H2.66912V8.66522H0.703125C1.02179 12.1772 3.82379 14.9799 7.33579 15.2979V13.3319H8.66913V15.2979C12.1811 14.9792 14.9838 12.1772 15.3018 8.66522H13.3358ZM11.3358 8.66522H7.68246L4.39912 4.56122L5.44046 3.72789L8.32313 7.33189H11.3365L11.3358 8.66522Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12070_274859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.406d49e1b62d74204acd6bbf1b00e44f.svg";
export { ForwardRef as ReactComponent };